jQuery(document).ready(function($){
    $(window).bind("resize", function () {
        if ($(this).width() > 768) {
            $('body').addClass('megaNav');
            megaNav();
        } else {
            $('body').removeClass('megaNav');
        }
      }).trigger('resize');
      
    function megaNav() {
        $('.header__inline-menu ul.list-menu > li.first-lvl').on('mouseenter',function() { 
            if($(this).hasClass('site-nav--has-centered-dropdown')){
                $(this).addClass('hover');
                $(this).siblings().removeClass('hover');
                $(this).find('.header__submenu').addClass('open');
                $(this).find('.mega-collection li.collection-mega:first-of-type').addClass('hover');
            }else {
                $('.header__inline-menu ul.list-menu > li.first-lvl').removeClass('hover');
                $('body').find('.header__submenu').removeClass('open');
            }
            
        });
        $('.header__submenu .collection-mega').on('hover',function() { 
            $(this).addClass('hover');
            $(this).siblings().removeClass('hover');
        });
        $('body.megaNav .header__submenu.list-menu--disclosure').on('mouseleave',function() {
            //  console.log('ssss');
             $('body').find('.header__submenu').removeClass('open');
             $('.header__inline-menu ul.list-menu > li.first-lvl').removeClass('hover');
        });
    }
       // Mobile menu
       $(window).bind("resize", function () {
      
        if ($(this).width() < 1024) {
            $("body").removeClass("preload");
        }
        if ($(this).width() < 1470) {
            $('body').addClass('mobMenu');
            // mobileMenu();
        } else {
            $('body').removeClass('mobMenu');
        }
      
      }).trigger('resize');
      
      function mobileMenu() {
        $('.mobile-hamburger').click(function () {
            $("body").addClass('mobMenu-open');
            $('.mobile-menu').addClass('overflow');
            $(".mobile-menu-links").addClass('open');
            $('.mobile-menu-links.open li .svg-icon').click(function (e) {
              e.preventDefault();
              $(this).siblings('.site-nav__dropdown').toggleClass('active');
            });
        });
      
        // $('.mobMenu .mobile-menu-links.open .header-middle-block:before').click(function () {
        //     $("body").removeClass('mobMenu-open');
        //     $(".mobile-menu-links").removeClass('open');
        // });
        
      
        $('.close-hamburger').click(function () {
            $("body").removeClass('mobMenu-open');
            $(".mobile-menu-links").removeClass('open');
            $('.mobile-menu').removeClass('overflow');
        });
        
        
      }



// POPUP

if ($(' .open-modal').length) {
     $.each($('.open-modal'), function (key, value) {

        $(this).click(function () {

             var modalClass = $(this).attr('data-modal');

                var popupED = $('body').find(".popup-content[data-content-modal='" + modalClass + "']");
                popupED.addClass('open');

                $('body').append("<div class='popup-overlay'></div>");
                $('html').css('overflow', 'hidden');

                $(window).on("resize", function () {
                    var wH = $(window).height();
                    var modalHeight = popupED.height();

                    if (modalHeight >= wH) {
                        $('body').find(".popup-content[data-content-modal='" + modalClass + "'] .modal-body").css('max-height', wH - 10);
                    }
                }).resize();

            });
        });

        $('.popup-content .close').click(function () {
            $('.popup-content').removeClass('open');
            $('body .popup-overlay').remove();
            $('html').css('overflow', 'auto');
        })

        $(document).mouseup(function (e) {
            var container = $(".popup-content.open");

            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.removeClass('open');
                $('body .popup-overlay').remove();
                $('html').css('overflow', 'auto');
            }
        });
    }


    updateRecharge();
	
    function updateRecharge() {
        // console.log('zzzz');
		
        var subscriptionInputs = $('.rc_widget__option');
        var inputVal = $(subscriptionInputs).find('input[name=purchase_option]:checked').val();
		
//        console.log(inputVal);
		
        $('#product-form-product').attr('data-variant-price',inputVal);
		
        $(subscriptionInputs).find('input[name=purchase_option]').on('change', function(){
            var newVal = $(this).val();
            var classess = $(this).attr('class');
            var ids = $(this).attr('id');
			
//            console.log($(this).attr('class'));
			
            $('#product-form-product').attr('data-variant-price',newVal);
			
//            console.log(classess);
			
            if (classess.indexOf("one-time") >= 0){
                $('input.selling-plan').attr('value', '');  
                $('.custom_purchase_option_subscription.per-subscription').attr('checked', false).removeClass('active');
                $('.custom_purchase_option.one-time').attr('checked', true).addClass('active');

                 $('.subscription-frequency-select').hide();
            }else{
                console.log($('input.selling-plan').attr('sellingPlan-id'));
                $('.custom_purchase_option_subscription.per-subscription').attr('checked', true);
                $('.custom_purchase_option.one-time').attr('checked', false);
                 $('.subscription-frequency-select').show();
                $('input.selling-plan').val($('input.selling-plan').attr('sellingPlan-id'));
            }
            // console.log(inputVal);
        });
		
        var selectPlan = $('.custom-rc-widget').find('select.product_option_plans_dropdown');
		
        $(selectPlan).on('change', function() {
            console.log($(this).val());
            $(this).siblings('input.selling-plan').val( $(this).val());
        });
        
    }


    // Load More
    if($('.recipes-articles').length){
        var size_recipe = $(".recipes-articles .single-recipe").size();
        console.log(size_recipe);
        var x=12;
        if(size_recipe <= x){
            $('#loadmore').hide();
        }else{
            $('#loadmore').show();
        }
        $('.recipes-articles .single-recipe:lt('+x+')').show();
        $('#loadmore').click(function (e) {
            e.preventDefault();
            x= (x+3 <= size_recipe) ? x+3 : size_recipe;
            $('.recipes-articles .single-recipe:lt('+x+')').show();
            if(size_recipe <= x){
                $(this).hide();
            }else{
                $('#loadmore').show();
            }
        });
        // $('#showLess').click(function () {
        //     x=(x-5<0) ? 3 : x-5;
        //     $('#myList li').not(':lt('+x+')').hide();
        // });


    }


    if($(window).width() <= 750){
        stickyAddToCart();
    }
    $(window).on('resize', function(){
        var win = $(this); //this = window
        if (win.width() <= 750) { 
            stickyAddToCart();
        }else {
            return;
        }
    });

    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
    
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();
    
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    function stickyAddToCart(){
        var lastScrollTop = 0;
        $(window).scroll(function () {
            var st = $(this).scrollTop();
            if (st > lastScrollTop){
                $('.product-form__item--submit').each(function () {
                    if (isScrolledIntoView(this) === true) {
                        $(this).addClass('fixed');
                    }
                });
            } else {
                if ($(window).scrollTop() <= $(window).height()) {
                    $('.product-form__item--submit').removeClass('fixed');
                }
            }
            lastScrollTop = st;
        });
    }
    
    
    if($(".article-template__content").length > 0) {
        var txt = $(".article-template__content")[0].textContent,
        wordCount = txt.replace( /[^\w ]/g, "" ).split( /\s+/ ).length;
        var readingTimeInMinutes = Math.floor(wordCount / 228) + 1;
        var readingTimeAsString = readingTimeInMinutes + " min";
        $('article .reading-time').html(readingTimeAsString);
    };

    if($('#CustomerCare').length){
        $('#CustomerCare').responsiveTabs({
            startCollapsed: 'accordion',
            setHash: true
        });
        $('#faq').responsiveTabs({
            startCollapsed: 'accordion',
            active: 0,
            activate: function(event, tab){
              accordionsF(tab.selector);
            },
            deactivate: function(event, tab){
              $(tab).unbind(accordionsF(tab.selector));
            },
        });
        
        accordionsF()
        
        function accordionsF(tabId){
        
            var animTime = 300,
                clicked = false;  
          $(tabId+' .faq-accordion').each(function () {
              $(this).find('.answer').css("height", 0)
              $(this).find('.question').click(function () {
                  if (!clicked) {
                      clicked = true;
                      var currIndex = $(this).index('.question'),
                      targetHeight = $('.answer > .inner').eq(currIndex).outerHeight(),
                      curentEl = $(this).siblings('.answer').first();
        
                      if(!$(this).hasClass('active-faq')){
                          $(this).addClass('active-faq').siblings().removeClass('active-faq');
                          $('.answer').stop().animate({ height: 0 }, animTime);
                          $('.answer').eq(currIndex).addClass('active-answer').stop().animate({ height: targetHeight }, animTime).siblings().removeClass('active-answer');
                      }else {
                          $(this).removeClass('active-faq');
                          $('.answer').eq(currIndex).stop().animate({ height: 0 }, animTime).removeClass('active-answer');
                      }
                        setTimeout(function () { clicked = false; }, animTime);
                      
                  }
        
              });
          });
        }
    }
	
	$('[name="purchase_option"]').change(function(){
		
		var $this = $(this);
		
//		console.log($this);
		
		if( $this.hasClass('one-time') ){
			$('.subscription-frequency').hide();
		}else{
			$('.subscription-frequency').show();
		}
		
	});

    
});

